import { apiClient } from '../client';
import type { AclPermission, OwnerType } from '@never2busy/shared';

export interface AclEntry {
  id: number;
  ownerType: OwnerType;
  ownerId: number;
  userId: number;
  permission: AclPermission;
  user: { id: number; firstName: string; lastName: string; email: string };
}

export const aclApi = {
  async list(ownerType: OwnerType, ownerId: number): Promise<AclEntry[]> {
    const { data } = await apiClient.get<AclEntry[]>('/acl', {
      params: { ownerType, ownerId },
    });
    return data;
  },
  async grant(
    ownerType: OwnerType,
    ownerId: number,
    userId: number,
    permission: AclPermission,
  ): Promise<AclEntry> {
    const { data } = await apiClient.post<AclEntry>('/acl', {
      ownerType,
      ownerId,
      userId,
      permission,
    });
    return data;
  },
  async revoke(id: number): Promise<void> {
    await apiClient.delete(`/acl/${id}`);
  },
};
